import { render, staticRenderFns } from "./shopReturnAddressManage.vue?vue&type=template&id=694086d3&scoped=true"
import script from "./shopReturnAddressManage.vue?vue&type=script&lang=js"
export * from "./shopReturnAddressManage.vue?vue&type=script&lang=js"
import style0 from "./shopReturnAddressManage.vue?vue&type=style&index=0&id=694086d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694086d3",
  null
  
)

export default component.exports